<template>
  <div class="p-6">
    <vs-tabs>
      <vs-tab label="Demandes">
        <div
          class="flex items-center pb-4 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
          <vs-select
            label="Contrat"
            v-model="selectedContract"
            autocomplete placeholder="Sélectionner un contrat"
            class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
            <vs-select-item v-for="item in contracts" :key="item.id" :value="item.id" :text="item.code_contract"/>
          </vs-select>

          <div>
            <span class="vs-select--label">Période</span>
            <date-range-picker
              ref="picker"
              :opens="opens"
              :locale-data=locale
              :singleDatePicker="singleDatePicker"
              :timePicker=false
              :showWeekNumbers="showWeekNumbers"
              :showDropdowns="showDropdowns"
              :autoApply="autoApply"
              v-model="dateRange"
              :ranges=false
              @update="updateValues"
              :linkedCalendars="linkedCalendars"
              :dateFormat="dateFormat"
              :always-show-calendars="false"
              :alwaysShowCalendars="alwaysShowCalendars"
              class="vs-inputx vs-input--input"
            >
              <div slot="input" slot-scope="picker" style="min-width: 350px;">
                {{ picker.startDate | date }} - {{ picker.endDate | date }}
              </div>
            </date-range-picker>
          </div>

          <div class="w-1/4 px-2">
            <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''"
              @click="getRequests(page, dateRange.startDate, dateRange.endDate), requestStats(), requestCounts(dateRange.startDate, dateRange.endDate)"
              style="margin-top: 18px;" color="primary"
              type="border" icon="search">Recherche
            </vs-button>
          </div>
        </div>
        <div class="py-6">
          <div class="vx-row">
            <div class="vx-col w-full md:w-3/4 mb-base">
              <vue-apex-charts v-if="!loading"
                               type="bar"
                               height="360"
                               :options="requestsCharts.options"
                               :series="requestsCharts.series"/>
            </div>
            <div
              class="border
                                border-b-0
                                border-r-0
                                border-solid
                                border-t-0
                                d-theme-border-grey-light
                                flex
                                flex-col
                                mb-base
                                md:w-1/4
                                vx-col
                                w-full">
              <div class="mb-4 border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
                <p class="mb-1 font-semibold">Toutes mes demandes</p>
                <p class="text-3xl">{{request_counts.total_my_request}}</p>
              </div>
              <div class="mb-4 border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
                <p class="mb-1 font-semibold">Demandes clôturées</p>
                <p class="text-3xl">{{request_counts.total_closed_request}}</p>
              </div>
              <div class="mb-4 border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
                <p class="mb-1 font-semibold">Demandes rejettées</p>
                <p class="text-3xl">{{request_counts.total_rejected_request}}</p>
              </div>
              <div class="mb-4 border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
                <p class="mb-1 font-semibold">Demandes en traitement</p>
                <p class="text-3xl">{{request_counts.total_on_treat}}</p>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div slot="no-body"
                   class="border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light mt-4">
                <vs-table :data="requests" class="table-dark-inverted" search>
                  <template slot="thead">
                    <vs-th>DEMANDE</vs-th>
                    <vs-th>TYPE</vs-th>
                    <vs-th>CONTRAT</vs-th>
                    <vs-th>PRIORITÉ</vs-th>
                    <vs-th>STATUT</vs-th>
                    <vs-th>EMIS PAR</vs-th>
                    <vs-th>ACTIONS</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <span>{{data[indextr].title}}</span>
                      </vs-td>
                      <vs-td><span>{{ tr.type }}</span></vs-td>
                      <vs-td><span>{{ tr.contract }}</span></vs-td>
                      <vs-td>
                        <vs-chip :color="getPriorityColor(tr.priority)">{{ tr.priority }}</vs-chip>
                      </vs-td>
                      <vs-td>
                        <vs-chip>{{ tr.status }}</vs-chip>
                      </vs-td>
                      <vs-td>{{tr.social_reason}}</vs-td>
                      <vs-td>
                                        <span class="flex cursor-pointer hover:text-primary"
                                              @click="goToSingle(tr.id, tr.has_proved)">
                                            <feather-icon
                                              icon="EyeIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                            /> Détails
                                        </span>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <br>
                <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>

    </vs-tabs>
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment';
  import VueApexCharts from 'vue-apexcharts';
  import Requests from "./requests";
  import {_buildQuery} from "../../../../helpers/helper";

  export default {
    components: {DateRangePicker, VueApexCharts, Requests},
    data() {
      return {
        locale: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Appliquer',
          cancelLabel: 'Annuler',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
          firstDay: 0
        },
        selectedContract: "",
        contracts: [],
        opens: 'center',
        minDate: '',
        maxDate: '',
        dateRange: {
          startDate: '',
          endDate: '',
        },
        singleDatePicker: false,
        showDropdowns: true,
        autoApply: false,
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,

        requestsCharts: {
          options: {
            title: {
              text: '',
              align: 'left'
            },
            chart: {
              // stacked: true,
              type: 'bar',
              toolbar: {show: true},
              zoom: {enabled: true}
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            colors: ['#008ffa', '#067A2F', '#ff0003'],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
              },
            },
            xaxis: {
              categories: [],
            },

          },
          series: []
        },

        invoicesCharts: {
          options: {
            title: {
              text: 'Contrat CC076736-2019 du 10/12/2019 - 20/12/2019',
              align: 'center'
            },
            chart: {
              type: 'bar',
              toolbar: {show: true},
              zoom: {enabled: true}
            },
            colors: ['#067A2F', '#ff0003'],

            xaxis: {
              categories: ['10/12/2020', '11/12/2020', '15/12/2020', '17/12/2020', '18/12/2020', '20/12/2020'],
            },
            yaxis: {
              labels: {
                formatter: function (value) {
                  return value + "  F";
                }
              },
            },

          },
          series: [
            {
              name: 'Factures',
              data: [450000, 345000, 500000, 600000, 600000, 445000]
            },
            {
              name: 'Règlements',
              data: [450000, 345000, 500000, 300000, 0, 0]
            },
          ]
        },

        loading: false,
        requests: [],
        last_page: null,
        page: 1,
        request_counts: {
          total_my_request: 0,
          total_closed_request: 0,
          total_rejected_request: 0,
          total_on_treat: 0
        }
      }
    },
    watch: {
      page: function (value) {
        this.getRequests(this.page, this.dateRange.startDate, this.dateRange.endDate)
      }
    },
    methods: {
      updateValues(values) {
        //console.log('event: update', {...values})
        this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
        this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
      },
      checkOpen(open) {
        console.log('event: open', open)
      },
      dateFormat(classes, date) {
        let yesterday = moment().subtract(1, 'day');
        if (!classes.disabled) {
         // classes.disabled = moment(date).isSame(yesterday, 'day')
        }
        return classes
      },
      getContracts() {
        this.$vs.loading()
        let customer_id = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem('userInfo')).id : ""
        let params = {
          customer_id: customer_id
        }
        this.$http.get('contracts' + _buildQuery(params)).then((response) => {
          this.contracts = response.data.data
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      goToSingle(id, el) {
        let t = el ? 1 : 2
        this.$router.push('/requests/' + id + '/detail/' + t)
      },
      getPriorityColor(priority) {
        priority = priority.toLowerCase();
        if (priority === "normale") return "primary";
        if (priority === "basse") return "success";
        if (priority === "haute") return "danger";
        return "primary";
      },
      getRequests(page, date_start = "", date_end = "") {
        let params = {
          page: this.page,
          contract: this.selectedContract !== "" ? this.selectedContract : "",
          date_start: date_start,
          date_end: date_end
        }
        this.$vs.loading()
        this.$http.get('statistics/customer/request/list' + _buildQuery(params)).then((response) => {
          this.requests = response.data.data
          this.last_page = response.data.last_page;
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      requestCounts(date_start = "", date_end = "") {
        this.$vs.loading()
        let params = {
          date_start: date_start,
          date_end: date_end,
          contract: this.selectedContract !== "" ? this.selectedContract : "",
        }
        this.$http.get('statistics/customer' + _buildQuery(params)).then((response) => {
          this.request_counts = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      requestStats() {
        this.loading = true;
        this.requestsCharts.series = []
        this.requestsCharts.options.xaxis.categories = []
        this.$vs.loading()
        let params = {
          contract: this.selectedContract !== "" ? this.selectedContract : "",
          date_start: this.dateRange.startDate,
          date_end: this.dateRange.endDate,
        }
        this.$http.post('statistics/customer/request/global/stats', params).then((response) => {
          const datas = response.data;
          datas.stats.forEach((data) => {
            this.requestsCharts.series.push({
              name: data.name,
              data: data.data
            })
          })
          this.requestsCharts.options.xaxis.categories = datas.days
          this.requestsCharts.options.title.text = this.getContractCode() ? "Contrat " + this.getContractCode() + " du "
            + moment(this.dateRange.startDate).format('DD/MM/YYYY') + " - " + moment(this.dateRange.endDate).format('DD/MM/YYYY') :
            this.getContractCode() + " du " + moment(this.dateRange.startDate).format('DD/MM/YYYY') + " - " + moment(this.dateRange.endDate).format('DD/MM/YYYY');
          this.loading = false
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          this.loading = false;
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      getContractCode() {
        if (this.selectedContract !== "") {
          let index = this.contracts.findIndex(x => x.id === this.selectedContract);
          return this.contracts[index].code_contract
        }
        return "";
      }
    },
    mounted() {
      this.getContracts();
      this.getRequests(this.page)
    }
  }
</script>

<style lang="scss">
  .reportrange-text {
    padding: 0 !important;
    border: 0 !important;
  }

  .vue-daterange-picker {
    -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.14) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.14) !important;

    border: none !important;
    padding: 8px !important;
    font-size: 1rem !important;
  }
</style>
